/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createContext } from "react";

/** @type {FormContext} */
const defaultContext = {};

export const FormContext = createContext(defaultContext);

/**
 * @typedef {object} FormContext
 * @property {FormReducerState} state
 * @property {import('react').Dispatch<FormReducerAction>} dispatch
 */
